<!--事件告警弹窗
打开状态下数据列一直累加显示，关闭后清空
-->
<template>
  <transition>
    <div class="event-box" v-if='isShow'>
      <!--isShow-->
      <div class="mask"></div>
      <div class="event-content">
        <p class="titles">
          <span class="t_title">事件告警</span>
          <img @click.stop='close' :src="closeImg" class="closeImage" />
        </p>
        <div :style="msvalue">
          <div class="buttonLine">
            <iconButton icoName="wedoButton/confirm.png" buttonText="确认事件" @buttonClick="confirmEvent"
              style="color: black;"></iconButton>
            <iconButton icoName="wedoButton/delete.png" buttonText="停止警报" @buttonClick="closeWarn"
              style="color: black;"></iconButton>
            <iconButton icoName="wedoButton/confirm.png" buttonText="全选" @buttonClick="selectAll" style="color: black;">
            </iconButton>
          </div>
          <infoList style='height: calc(100% - 0.5rem);' :columns="eventColumns"
            @selectPage="nowPageIndex = $event,nowEventList = []" :titleStyle='{"background":"white"}'
            :dataList="nowPage" :noStyle="{color:'black'}" :pageLen="10" :totalSize="eventList.length" :fillAll="true"
            spanColor='black'>
            <img slot="control" slot-scope="slotProps" :src="getImg(slotProps.item)"
              style="width: 16px;height: 16px;padding: 4px;display: block;margin: 0 auto;"
              v-if="slotProps.item != undefined" @click.stop="checkEvent(slotProps.item)">
          </infoList>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import infoList from '@/components/module/universal/infoList.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import eventApi from '@/components/api/eventApi.js'
  import resourcesStore from '@/cache/resourcesStore.js'
  import socketStore from '@/cache/socketStore.js'

  export default {
    components: {
      infoList,
      iconButton,
    },
    props: {

    },
    data () {
      return {
        eventColumns: [{
          name: '选中',
          type: 'slot',
          key: 'control',
          getTdStyleMethod () {
            return {
              'min-width': 0,
            }
          }
        },{
          name: "事件类型",
          key: "typeName",
        },
        {
          name: "设备名称",
          key: "linkObject",
        },
        {
          name: "单位名称",
          key: "unitName",
          weight: 2
        },
        {
          name: "内容",
          key: "description",
          getTdStyleMethod () {
            return {
              "text-align": 'left'
            }
          },
          weight: 3
        },{
          name: "时间",
          key: "eventtime",
          weight: 2,
          format (item) {
            if(isempty(item)) {
              return ''
            }
            return new Date(item).formatByTime('-')
          }
        },{
          name: "确认人",
          key: "confirmuser",
        },{
          name: "确认时间",
          key: "confirmtime",
          weight: 2,
          format (item) {
            if(isempty(item)) {
              return ''
            }
            return new Date(item).formatByTime('-')
          }
        }
        ],
        isShow: false,
        eventList: [],
        nowPageIndex: 0,
        nowEventList: [],
        uuidToEvent: {},
        checkType: 'checkall',
      }
    },
    created () {
      debugPage=this
    },
    mounted () {

    },
    destroyed () {},
    computed: {
      getColorById () {
        return id => {
          return resourcesStore.getters.getColorById(id)
        }
      },
      msvalue () {
        return {
          // 'background': this.getColorById('secondMenuBG'),
          'border': '1px solid #D6D6D6',
          'min-height': '1rem',
          'height': 'calc(100% - 0.51rem)',
          // 'padding': '.1rem',
          'overflow': 'hidden',
          'overflow-y': 'auto',
        }
      },
      getBackgroudImageStyle () {
        return resourcesStore.getters.getBackgroudImageStyle
      },
      closeImg () {
        return resourcesStore.getters.getResourcesByName('wedoButton/close.png')
      },
      nowPage () {
        var list=copy(this.eventList.slice(this.nowPageIndex*10,this.nowPageIndex*10+10))
        list.forEach(item => {
          item.control={
            isShow: 'true'
          }
          var e=this.uuidToEvent[item.uuid]
          if(e!=undefined) {
            item.confirmuser=e.confirmuser
            item.confirmtime=e.confirmtime
            item.eventtime=e.eventtime
          }
        })
        return list
      },
      nowPageNos () {
        var list=[]
        this.nowPage.forEach(item => {
          list.push(item.eventTag.No)
        })
        return list.join(',')
      },
      getImg () {
        return event => {
          return this.nowEventList.findIndex(item => item.uuid==event.uuid)!=-1? resourcesStore.getters.getResourcesByName(
            '/checkBox/icon_checked.png'):resourcesStore.getters.getResourcesByName('/checkBox/icon_uncheck.png')
        }
      }
    },
    watch: {
      eventList (nv,ov) {
        //变化时刷新一下详情，这个数据量不会很大
        var newUUIDToEvent={}
        var ids=nv.map(item => item.uuid).join(',')
        if(ids.length==0) {
          this.uuidToEvent=newUUIDToEvent
          return
        }
        eventApi.searchEventByUuids(ids,result => {
          for(var i=0,len=result.length;i<len;i++) {
            var item=result[i]
            newUUIDToEvent[item.uuid]=item
          }
          this.uuidToEvent=newUUIDToEvent
        })
      }
    },
    methods: {
      open (list) {
        this.eventList=list
        this.isShow=true
        //如果当前列表里面有告警，就一直响到关闭为止
        this.$dialogMethod.playWarn()
      },
      close () {
        this.isShow=false
        this.closeWarn()
        //清空数据
        socketStore.state.realTimeEvent=[]
      },
      confirmEvent () {
        if(this.nowEventList==[]) {
          this.$dialogMethod.showMessage("请先选择事件!")
          return
        }
        var uuids=this.nowEventList.map(item => item.uuid).join(',')
        if(isempty(uuids)) {
          return
        }
        eventApi.confirmEventByUuids(uuids,respon => {
          this.$dialogMethod.showMessage("事件确认成功！")
          if(respon.length!=0) {
            err('部分事件没有成功确认:'+respon)
          }
          //刷新对应事件
          eventApi.searchEventByUuids(uuids,result => {
            for(var i=0,len=result.length;i<len;i++) {
              var item=result[i]
              this.$set(this.uuidToEvent,item.uuid,item)
            }
          })
          //清空选中
          this.nowEventList=[]
        })

      },
      checkEvent (event) {
        if(event==undefined) {
          return
        }
        var index=this.nowEventList.findIndex(item => item.uuid==event.uuid)
        var isChecked=index!=-1
        if(isChecked) {
          //取消选中
          this.nowEventList.remove(index)
        } else {
          this.nowEventList.push(event)
        }
      },
      selectAll () {
        //获取当前页面的所有列
        var isAll=true
        var allIds=this.nowEventList.map(item => item.uuid).join(',')
        for(var i=0,len=this.nowPage.length;i<len;i++) {
          var item=this.nowPage[i]
          if(!allIds.includes(item.uuid)) {
            isAll=false
            break
          }
        }
        if(isAll) {
          //取消全选
          this.nowEventList=[]
        } else {
          //全选
          this.nowEventList=this.nowPage
        }
      },
      closeWarn () {
        this.$dialogMethod.pauseWarn()
      }
    },
  }
</script>

<style scoped>
  .event-box .t_title {
    float: left;
    color: black;
  }

  .event-box .closeImage {
    float: right;
    width: .2rem;
    height: .2rem;
    cursor: pointer;
  }

  .event-box {
    position: absolute;
    width: auto;
    height: auto;
  }

  .event-box .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
  }

  .event-box .event-content {
    z-index: 999;
    position: fixed;
    top: 20%;
    left: 0;
    right: 0;
    margin: auto;
    width: 10rem;
    padding: 0;
    background: white;
    border-radius: .06rem;
    color: black;
    margin-top: .7rem;
    text-align: center;
    padding: 0.1rem;
    height: 57%;
  }

  .event-box .event-content .info-list-table {
    color: black !important;
  }

  .event-box .titles {
    color: #5C5B61;
    margin-bottom: .1rem;
    font-weight: 1000;
    height: 20px;
  }

  .event-box .msvalue {
    background: #FFFFFF;
    border: 1px solid #D6D6D6;
    min-height: 1rem;
    height: 90%;
    overflow: hidden;
  }

  .event-box .wedoButton-body span {
    color: black !important;
  }
</style>